import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AdminRoute = () => {
  const { isAdminAuthenticated } = useContext(AuthContext);

  // Check admin token directly from localStorage (separate from user auth)
  const isAdmin = isAdminAuthenticated();

  return isAdmin ? <Outlet /> : <Navigate to="/admin/login" />;
};

export default AdminRoute;
